import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { IconComponent } from '../../../../components/icon/icon.component';
import { TranslatePipe } from '../../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-star-rating',
  templateUrl: 'star-rating.component.html',
  styleUrls: ['star-rating.component.scss'],
  imports: [
    TranslatePipe,
    IconComponent
  ]
})

export class StarRatingComponent {
  private readonly defaultStars: number = 5;

  stars: InputSignal<number> = input<number>(0);

  readonly iconStates: Signal<Array<boolean>> = computed(() => {
    const currentStars = this.stars();
    const adjustedStars = currentStars > this.defaultStars ? this.defaultStars : currentStars;

    const states: Array<boolean> = [];
    for (let i = 0; i < this.defaultStars; i++) {
      states.push(adjustedStars > i);
    }
    return states;
  });
}
